/**
 * My Going Events Page
 * Shows all events the user has marked as going
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import Navbar from '../components/Navbar';

const MyGoingEventsPage = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchGoingEvents();
  }, []);

  const fetchGoingEvents = async () => {
    try {
      const response = await apiClient.get('/events/going');
      if (response.data.success) {
        setEvents(response.data.events);
      }
    } catch (err) {
      setError('Failed to load events');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'short', 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  if (loading) {
    return <div style={{ padding: '50px', textAlign: 'center' }}>Loading...</div>;
  }

  if (error) {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <p style={{ color: 'red' }}>{error}</p>
        <button onClick={() => navigate('/')}>Go Home</button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '1000px', margin: '50px auto', padding: '20px', paddingTop: '140px' }}>
<Navbar />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h1>Events I'm Going To</h1>
        <button 
          onClick={() => navigate('/')}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Back to Home
        </button>
      </div>

      {events.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <p>You haven't marked any events as going yet.</p>
          <button 
            onClick={() => navigate('/events')}
            style={{ 
              marginTop: '20px',
              padding: '10px 20px', 
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Browse Events
          </button>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '20px' }}>
          {events.map((event) => (
            <div 
              key={event.id}
              onClick={() => navigate(`/events/${event.id}`)}
              style={{ 
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '20px',
                cursor: 'pointer',
                backgroundColor: '#fff',
                transition: 'box-shadow 0.2s',
                display: 'flex',
                gap: '20px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
            >
              {/* Flyer Image */}
              <div style={{ flexShrink: 0 }}>
                <img 
                  src={event.flyer_url} 
                  alt={event.title}
                  style={{ 
                    width: '150px', 
                    height: '150px', 
                    objectFit: 'cover',
                    borderRadius: '4px'
                  }}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/150x150?text=No+Image';
                  }}
                />
              </div>

              {/* Event Info */}
              <div style={{ flex: 1 }}>
                <div style={{ 
                  display: 'inline-block',
                  backgroundColor: '#28a745',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  marginBottom: '10px'
                }}>
                  ✓ Going
                </div>

                <h2 style={{ marginTop: 0, marginBottom: '10px' }}>{event.title}</h2>
                
                <p style={{ margin: '5px 0', color: '#666' }}>
                  <strong>📅 Date:</strong> {formatDate(event.event_date)}
                </p>
                
                <p style={{ margin: '5px 0', color: '#666' }}>
                  <strong>🕐 Doors:</strong> {formatTime(event.door_time)} | <strong>Music:</strong> {formatTime(event.music_time)}
                </p>
                
                <p style={{ margin: '5px 0', color: '#666' }}>
                  <strong>📍 Location:</strong> {event.city}, {event.state}
                </p>
                
                <p style={{ margin: '5px 0', color: '#666' }}>
                  <strong>💵 Price:</strong> {event.ticket_price === 0 ? 'Free' : `$${event.ticket_price}`}
                </p>

                {event.genre_tags && event.genre_tags.length > 0 && (
                  <div style={{ marginTop: '10px' }}>
                    {event.genre_tags.map((genre, index) => (
                      <span 
                        key={index}
                        style={{ 
                          display: 'inline-block',
                          backgroundColor: '#e0e0e0',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          marginRight: '5px',
                          marginTop: '5px'
                        }}
                      >
                        {genre}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyGoingEventsPage;
